import React, { Component } from "react";
import { Modal } from "antd";
import { connect } from "react-redux";
import { closeModal } from "./modalActions";
import ImageModal from "../whatsappOrders/Modal/ImageModal";

class WhatsappImageModal extends Component {
  state = {};
  render() {
    const { closeModal, imgData } = this.props;
    return (
      <Modal
        title="Whatsapp Order Image"
        visible={true}
        onCancel={closeModal}
        onOk={closeModal}
        footer={null}
      >
        <ImageModal imgData={imgData} />
      </Modal>
    );
  }
}
const actions = { closeModal };
const mapStateToProps = state => ({});

export default connect(
  mapStateToProps,
  actions
)(WhatsappImageModal);
